import { AxiosInstance } from 'axios/index';
import { type PaginatedList, type VideoPostRes } from '@shared/types/common';
import type { ExerciseVideo } from '@shared/types/exercises';
import { EntityByIdParam, ModuleParam } from '@src/api/types.ts';

const exercisesUrl = '/videos/exercise_videos/';

export class ExercisesApi {
  constructor(private instance: AxiosInstance) {}

  public async getList(params: ExercisesListParams) {
    return this.instance
      .get<PaginatedList<ExerciseVideo>>(exercisesUrl, { params })
      .then((res) => res.data);
  }

  public async getById({ id }: EntityByIdParam) {
    return this.instance.get<ExerciseVideo>(exercisesUrl + `${id}/`).then((res) => res.data);
  }

  public async create({ exerciseData, params }: CreateExerciseVideoDto) {
    return this.instance.post<VideoPostRes>(
      exercisesUrl + `?module=${params.module}`,
      exerciseData
    );
  }

  public async update({ exerciseData, params, id }: UpdateExerciseVideoDto) {
    return this.instance.patch<ExerciseVideo>(
      exercisesUrl + `${id}/?module=${params.module}`,
      exerciseData
    );
  }

  public async delete({ id }: EntityByIdParam) {
    return this.instance.delete<ExerciseVideo>(exercisesUrl + `${id}/`);
  }
}

export type CreateExerciseVideoDto = {
  exerciseData: FormData;
  params: { module?: number };
  isTempExercise?: boolean;
};
export type UpdateExerciseVideoDto = {
  exerciseData: FormData;
  params: { module?: number };
} & EntityByIdParam;
export type ExercisesListParams = Partial<
  ModuleParam & {
    page: number;
    tags?: string;
    search?: string;
    library?: string;
    partitions?: string;
  }
>;
